import { render, staticRenderFns } from "./SmsTemplateComponent.vue?vue&type=template&id=f5bf214a&scoped=true"
import script from "./SmsTemplateComponent.vue?vue&type=script&lang=js"
export * from "./SmsTemplateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bf214a",
  null
  
)

export default component.exports